import { Injectable } from '@angular/core';
import { AppConsts } from '../AppConsts';

@Injectable()
export class AppAuthService {

    logout(reload?: boolean): void {
        abp.auth.clearToken();
		abp.utils.setCookieValue(AppConsts.authorization.encryptedAuthTokenName, undefined, undefined, abp.appPath);
        if (reload !== false) {
            //console.log('MY URL', AppConsts.appBaseUrl);
            location.href = AppConsts.appBaseUrl;
        }
    }
}
